import React, {ReactElement} from "react";

import {CTA} from "../../buttons/cta-button/CTAButton";
import {MaybeType} from "/src/types";
import {visibleForLocale} from "/src/utils/utils";
import {LOCALE} from "/src/config";

import PromoBanner from "../promo-banner/PromoBanner";
import NavigationWrapper from "../navigation/NavigationWrapper";

import * as styles from "./header.module.scss";

export interface HeaderProps {
  newNavIsRenderedIn: MaybeType<Array<string>>;
  handlePromoBannerClose: () => void;
  isPromoBannerVisible: boolean;
  isSticky: boolean;
  promoBannerData?: MaybeType<Queries.PromoBannerFragmentFragment>;
  hideNotificationBar?: boolean;
}

interface PromoBannerProps {
  cta: CTA;
  title: string;
  visible: boolean;
}

const PromoBannerPlaceholder = (props: PromoBannerProps): ReactElement => {
  const {cta, title, visible} = props;

  return (
    <div className={styles.header__promoBannerPlaceholder}>
      {visible && (
        <PromoBanner title={title} cta={cta} handleClose={() => {}} />
      )}

      <div className={styles.header__placeholder} />
    </div>
  );
};

const Header = (props: HeaderProps): ReactElement | null => {
  const {
    isSticky,
    promoBannerData,
    isPromoBannerVisible,
    handlePromoBannerClose,
    newNavIsRenderedIn,
    hideNotificationBar = false,
  } = props;

  if (!visibleForLocale(newNavIsRenderedIn as Array<string>, LOCALE)) {
    return null;
  }

  return (
    <header id="header" className={styles.header}>
      {/* This component pushes the main content down the correct height without having to use a window resize event. */}
      <PromoBannerPlaceholder
        title={promoBannerData?.title!}
        cta={promoBannerData?.cta as CTA}
        visible={isPromoBannerVisible}
      />

      {isPromoBannerVisible && (
        <PromoBanner
          title={promoBannerData?.title!}
          cta={promoBannerData?.cta as CTA}
          handleClose={handlePromoBannerClose}
        />
      )}

      <NavigationWrapper
        isSticky={isSticky}
        hideNotificationBar={hideNotificationBar}
      />
    </header>
  );
};

export default Header;
